/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Subscribed_Success_Title_CnaInputs */

const en_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const ar_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const de_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const es_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const fr_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const it_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const ja_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const ko_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const pt_br_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const ru_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const th_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const tr_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Successful!`)
};

const zh_cn_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功购买 Plus 会员`)
};

const zh_tw_onboarding_paywall_subscribed_success_title_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功购买 Plus 会员`)
};

/**
* | output |
* | --- |
* | "Purchase Successful!" |
*
* @param {Onboarding_Paywall_Subscribed_Success_Title_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_subscribed_success_title_cna = /** @type {((inputs?: Onboarding_Paywall_Subscribed_Success_Title_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Subscribed_Success_Title_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "ar") return ar_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "de") return de_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "es") return es_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "fr") return fr_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "it") return it_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "ja") return ja_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "ko") return ko_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "ru") return ru_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "th") return th_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "tr") return tr_onboarding_paywall_subscribed_success_title_cna(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_subscribed_success_title_cna(inputs)
	return zh_tw_onboarding_paywall_subscribed_success_title_cna(inputs)
});